import { Button, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useGoBack from '../../hooks/useGoBack';
import BreadcrumbNav from '../BreadcrumbNav/BreadcrumbNav';

const DetailPageHeader = ({ title, breadcrumbsLinks, actionButtons }) => {
  const goBackHandler = useGoBack();
  return (
    <Stack direction="row" justifyContent="space-between" flexWrap="wrap">
      <Stack direction="row">
        <Button variant="text" size="large" startIcon={<ArrowBackIcon />} onClick={goBackHandler} />
        <Stack>
          <Typography color="textPrimary" variant="h5">
            {title || ''}
          </Typography>
          <BreadcrumbNav links={breadcrumbsLinks} sx={{ mt: 1 }} />
        </Stack>
      </Stack>
      {actionButtons && (
        <Stack direction="row" alignItems="center">
          {actionButtons}
        </Stack>
      )}
    </Stack>
  );
};

export default DetailPageHeader;
